<template>
  <BaseForm
    :key="feedId || 'new'"
    :title="formTitle"
    :formData="feedData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue';
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    feedId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      feedData: {
        name: ''
      },
      fields: [
        { model: 'name', label: 'Feed Name', required: true, type: 'text' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.feedId ? `Edit Feed` : 'Add Feed';
    },
    submitUrl() {
      return this.feedId ? `/api/v1/feed/feeds/${this.feedId}/` : '/api/v1/feed/feeds/';
    },
    method() {
      return this.feedId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.feedId) {
      this.loadFeedData();
    }
  },
  methods: {
    loadFeedData() {
      axios.get(`/api/v1/feed/feeds/${this.feedId}/`).then(response => {
        this.feedData = response.data;
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Feed saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the feed!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
